<div *ngIf="loading" class="filter-loader">
  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  <p>Loading....</p>
</div>
